import { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/", label: "Accueil", end: true },
    { to: "/nos-parfums", label: "Nos parfums" },
    { to: "/gouter", label: "Goûter" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`sticky top-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-arl-cream/90 backdrop-blur-md shadow-[0_4px_24px_-12px_rgba(36,85,99,0.25)]"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 py-3 flex items-center justify-between gap-6">
                <Link to="/" data-testid="navbar-logo-link" className="flex items-center gap-3 group">
                    <img
                        src="/images/logo-arlequin.webp"
                        alt="Arlequin Artisan Glacier"
                        className="h-12 sm:h-14 w-auto transition-transform group-hover:rotate-[-2deg]"
                    />
                </Link>

                <nav className="hidden md:flex items-center gap-1" data-testid="navbar-desktop-nav">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={`navlink-${l.to.replace(/\//g, "") || "home"}`}
                            className={({ isActive }) =>
                                `relative px-4 py-2 text-[15px] font-medium tracking-wide transition-colors ${
                                    isActive ? "text-arl-blue" : "text-arl-ink/70 hover:text-arl-blue"
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    {l.label}
                                    <span
                                        className={`absolute left-4 right-4 -bottom-0.5 h-[2px] rounded-full bg-arl-rose transition-transform origin-left ${
                                            isActive ? "scale-x-100" : "scale-x-0"
                                        }`}
                                    />
                                </>
                            )}
                        </NavLink>
                    ))}
                </nav>

                <Link
                    to="/nous-retrouver"
                    data-testid="navbar-cta-visit"
                    className="hidden md:inline-flex btn-primary text-sm py-2.5 px-5"
                >
                    Nous rendre visite
                </Link>

                <button
                    type="button"
                    data-testid="navbar-mobile-toggle"
                    aria-label="Ouvrir le menu"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden p-2 rounded-full text-arl-blue hover:bg-arl-blue/10 transition"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    className="md:hidden bg-arl-cream/95 backdrop-blur-md border-t border-arl-blue/10 px-5 py-4 flex flex-col gap-1"
                    data-testid="navbar-mobile-menu"
                >
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-navlink-${l.to.replace(/\//g, "") || "home"}`}
                            className={({ isActive }) =>
                                `py-3 px-3 rounded-lg text-base font-medium ${
                                    isActive
                                        ? "text-arl-blue bg-arl-blue/5"
                                        : "text-arl-ink/80 hover:bg-arl-blue/5"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/nous-retrouver"
                        onClick={() => setOpen(false)}
                        data-testid="mobile-navlink-visit"
                        className="mt-3 btn-primary justify-center text-sm py-3"
                    >
                        Nous rendre visite
                    </Link>
                </div>
            )}
        </header>
    );
}
